import React from 'react';
import StepIcon from '@mui/material/StepIcon';

const CustomStepIcon = (props) => {
  const { active, completed, icon } = props;

  const iconStyles = {
    color: active ? 'red' : completed ? 'green' : 'grey',
    '& .MuiStepIcon-root': { 
      fontSize: '2rem',
    },
    '& .MuiStepIcon-text': {
      fill: 'white',
    },
  };

  return (
    <StepIcon
      icon={icon}
      sx={iconStyles}
      completed={completed}
    />
  );
};

export default CustomStepIcon;